export default __webpack_public_path__ + "static/media/lightback.0c016d7d.jpg";